import React, { useEffect, useMemo, useRef, useState } from 'react';
const getPageUrls = pages => {
  if (!Array.isArray(pages) || pages.length === 0) return [];
  return pages.map(p => typeof p === 'string' ? p : p === null || p === void 0 ? void 0 : p.url).filter(Boolean);
};
export const DocumentPaged = ({
  metadata,
  playing = true,
  onReady,
  onEnded
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const {
    pages: rawPages,
    duration_per_page: rawDuration
  } = metadata;
  const durationPerPage = rawDuration * 1000 || 15;
  const pageUrls = useMemo(() => getPageUrls(rawPages), [rawPages]);
  const intervalRef = useRef(null);
  useEffect(() => {
    setCurrentIndex(0);
  }, [pageUrls, playing]);
  useEffect(() => {
    if (pageUrls.length === 0 || !playing) {
      onReady && onReady();
      return;
    }
    const loadImages = () => {
      const promises = pageUrls.map(src => new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = reject;
        img.src = src;
      }));
      return Promise.all(promises);
    };
    loadImages().then(() => onReady && onReady());
  }, [pageUrls, playing]);
  useEffect(() => {
    if (!playing) return;
    intervalRef.current = setInterval(() => {
      setCurrentIndex(prev => {
        if (prev >= pageUrls.length - 1) {
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
          onEnded && onEnded();
          return prev;
        }
        return prev + 1;
      });
    }, durationPerPage);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [playing, pageUrls.length, durationPerPage, onEnded]);
  if (pageUrls.length === 0) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "DocumentPaged"
  }, /*#__PURE__*/React.createElement("img", {
    src: pageUrls[currentIndex],
    alt: `Page ${currentIndex + 1}`,
    className: "image-page"
  }), /*#__PURE__*/React.createElement("div", {
    className: "images-pagination"
  }, pageUrls.map((_, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: `pagination-dots ${currentIndex === index ? 'dot-selected' : ''}`
  }))));
};